import React from 'react'

export const Footer = () => {
  return (
    <footer style={{backgroundColor : 'rgb(6, 17, 56)'}}> 
    <div style={{textAlign : 'center', padding: '10px'}}>All Rights Reserved - Designed by <a href="https://www.kuzeysoftware.com">Kuzey Software</a></div>
   
   </footer>
  )
}
